module.exports = __webpack_public_path__ + "img/hr-sand-decal-05.748c1f66.png";